import React, { useState, useEffect } from "react";
import { useCategoryContext } from "../../CategoryProvider";
import ProductsGrid from "~/assets/js/components/ProductsGrid";
import ProductCard from "~/assets/js/components/ProductCard";
import { useTransition, animated, config } from "@react-spring/web";
import NoProducts from "../../components/NoProducts";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie.js";
import { fetchStocks } from "~/assets/js/Api/ingredientsApi.js";
import useGroupOrder from "~/assets/js/global/useGroupOrder";
import { useFeatureFlagPayload } from "posthog-js/react";

const Products = () => {
    const [inStockProducts, setInStockProducts] = useState([]);
    const { state } = useCategoryContext();
    const { isGroupOrder } = useGroupOrder();
    const { products: productState } = state;
    const configuratorTest = useFeatureFlagPayload("configurator-card-test");
    let products = productState;
    if (configuratorTest?.url) {
        products = productState?.map((product) => {
            if (product.name.includes("Bowl: Konfigurator")) {
                product.image.src = configuratorTest.url;
                product.image.srcset = undefined;
            }
            return product;
        });
    }
    const productIds = products.map((product) => product.product_id);
    const cookie = useAreaCookie();
    const storeId = isGroupOrder ? cookie?.groupStore : cookie?.area?.store_id;

    useEffect(() => {
        const getInStockProducts = async () => {
            const stocks = await fetchStocks(productIds, storeId);
            setInStockProducts(stocks.data);
        };
        storeId && getInStockProducts();
    }, [cookie, isGroupOrder]);

    const isInStock = (product) => {
        if (!storeId) {
            return true;
        }
        const productId = product.product_id;
        const stockProduct = inStockProducts.find(
            (product) => product.id === productId
            //TODO not sure if this is still required
            //product.wordpress_id === productId ||
            //product.wordpress_alt_id === productId
        );
        return stockProduct ? stockProduct.in_stock : false;
    };

    const transitions = useTransition(products, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: config.stiff,
    });

    if (products.length < 1) {
        return <NoProducts />;
    }

    return (
        <div className="category-products">
            <ProductsGrid>
                {transitions((style, product) => {
                    const isAvailableInStore =
                        storeId &&
                        product.available_in_stores.includes(
                            storeId.toString()
                        );
                    const isMediumTermUnavailable =
                        !isInStock(product) && product.stock_management;
                    if (
                        (!product.store_specific_product ||
                            isAvailableInStore) &&
                        !isMediumTermUnavailable
                    ) {
                        return (
                            <animated.div style={style}>
                                <ProductCard
                                    key={`product-${product.id}`}
                                    product={product}
                                    inStock={isInStock(product)}
                                    storeId={storeId}
                                />
                            </animated.div>
                        );
                    }
                })}
            </ProductsGrid>
        </div>
    );
};

export default Products;
